import { useAllTaskTypes } from "@coworker/apprestructured/src/task-management/services/useTaskTypes";
import { useMemo } from "react";

export function useTasksTypes(
  taskTypeIds: string[],
  { enabled = true }: { enabled?: boolean } = {}
) {
  const { data, isLoading } = useAllTaskTypes({ enabled });

  const tasksTypes = useMemo(() => {
    if (!data) {
      return [];
    }

    if (!taskTypeIds.length) {
      return data;
    }

    return data.filter(({ id }) => taskTypeIds.includes(id));
  }, [taskTypeIds, data]);

  return { tasksTypes, isLoading };
}
